import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Alert, Col, Row, Space } from 'antd'
import styled from 'styled-components'
import { AppInput } from 'Components/form'
import { Theme } from 'Components/common'
import { ManageOnlineStockReq, StockListData } from 'Store/stock/types'
import { numberWithComma } from 'helpers/format'
import { PrimaryButton } from 'Components/button'
import { ConfirmDailog, EventModal } from 'Components/modal'
import { manageOnlineStockAPI } from 'Store/stock/api'
import { clearEventAction } from 'Store/stock/actions'
import { selectStockActionEvent } from 'Store/stock/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { AlertInfo } from 'Components/alert'

type Props = ReduxProps & {
  stockData?: StockListData
  onCloseDrawer: () => void
  onSuccess: () => void
}

const AllowcateForm: React.FunctionComponent<Props> = props => {
  const { stockData, onCloseDrawer, onSuccess, actionEvent, currentUser } = props

  const [confirmDialog, setConfirmDialog] = useState(false)
  const dispatch = useDispatch()
  const [formData, setFormData] = useState({
    online_quantity: 0,
    offline_quantity: 0,
  })

  const calculatePercent = (count: number) => {
    return ((count || 0) * 100) / (stockData?.quantity_all || 0)
  }

  const onSave = (): void => {
    const offlinePercent = Math.ceil(calculatePercent(formData.offline_quantity || 0))
    const req: ManageOnlineStockReq = {
      product_id: stockData?.product_id || 0,
      product_option_id: stockData?.product_option_id || 0,
      online_percentage: 100 - offlinePercent,
    }
    dispatch(manageOnlineStockAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onClickSave = (): void => {
    setConfirmDialog(true)
  }

  useEffect(() => {
    setFormData({
      offline_quantity: stockData?.quantity_offline || 0,
      online_quantity: stockData?.quantity || 0,
    })
  }, [stockData])

  const onUpdateData = (val: string, key: string) => {
    let value = parseInt(val)
    if (value > (stockData?.quantity_all || 0)) {
      value = stockData?.quantity_all || 0
    }
    let online = 0
    let offline = 0
    if (key === 'online_quantity') {
      online = value
      offline = (stockData?.quantity_all || 0) - (online || 0)
    } else {
      offline = value
      online = (stockData?.quantity_all || 0) - (offline || 0)
    }
    setFormData({
      ...formData,
      online_quantity: online,
      offline_quantity: offline,
    })
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    setConfirmDialog(false)
    clearEvent()
    onSuccess()
  }

  const ConfirmSaveDailog = (
    <ConfirmDailog
      title="ปรับจำนวนขาย Online / Offline"
      description={`คุณแน่ใจที่จะปรับปรับจำนวนขาย Online / Offline หรือไม่ ?`}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmDialog}
      handleOk={onSave}
      handleCancel={() => setConfirmDialog(false)}
      loading={false}
    />
  )

  const FooterContent = (
    <Row justify="center">
      <Col>
        <Space size="middle" align="baseline">
          <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
          <PrimaryButton text="บันทึก" onClick={onClickSave} />
        </Space>
      </Col>
    </Row>
  )

  const offlinePercent = Math.ceil(calculatePercent(formData.offline_quantity || 0))

  return (
    <Wrapper>
      <AlertInfo
        message="การปรับจำนวนสินค้าในช่อง จำนวนสินค้าออฟไลน์ และ จำนวนสินค้าออนไลน์ อาจมีจำนวนคาดเคลื่อนเล็กน้อย
        เนื่องจากระบบมีการแปลงจำนวนที่กรอกเป็น %"
        description=""
        showIcon
      />
      <br />
      <Space direction="vertical">
        <Space direction="horizontal" align="baseline">
          ปรับจำนวนสินค้าออฟไลน์
          <AppInput
            name="offline_quantity"
            label=""
            type="number"
            isRequired={true}
            isError={false}
            value={formData.offline_quantity}
            onChange={onUpdateData}
            resProps={{ suffix: stockData?.uom, min: 0 }}
          />
          <Remark>% ขายออฟไลน์ ≈ {numberWithComma(offlinePercent || 0, true, 0)}%</Remark>
        </Space>
        <Space direction="horizontal" align="baseline">
          ปรับจำนวนสินค้าออนไลน์
          <AppInput
            name="online_quantity"
            label=""
            type="number"
            isRequired={true}
            isError={false}
            value={formData.online_quantity}
            onChange={onUpdateData}
            resProps={{ suffix: stockData?.uom, min: 0 }}
          />
          <Remark>% ขายออนไลน์ ≈ {numberWithComma(100 - (offlinePercent || 100), true, 0)}%</Remark>
        </Space>
        {ConfirmSaveDailog}
        <EventModal
          event={[actionEvent]}
          enable={true}
          successCalback={onEventSuccess}
          errorCalback={clearEvent}
        />
      </Space>
      {FooterContent}
    </Wrapper>
  )
}

const Wrapper = styled.div``

const Remark = styled.div`
  font-size: ${Theme.typography.body5};
  color: ${Theme.colors.grey};
`

const mapStateToProps = (state: RootState) => {
  return {
    actionEvent: selectStockActionEvent(state),
    currentUser: selectCurrentUser(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(AllowcateForm)
